import React from 'react';
import { cn } from '@/lib/utils';

interface FormFieldProps {
  id: string;
  label?: string;
  type?: string;
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  error?: string;
  disabled?: boolean;
  autoComplete?: string;
  className?: string;
}

export const FormField: React.FC<FormFieldProps> = ({
  id,
  label,
  type = 'text',
  value,
  onChange,
  placeholder,
  error,
  disabled = false,
  autoComplete,
  className,
}) => {
  return (
    <div data-testid={`form-field-${id}`} className={cn('space-y-2', className)}>
      {label && (
        <label
          htmlFor={id}
          className="block text-sm font-medium text-slate-700 dark:text-slate-300"
        >
          {label}
        </label>
      )}

      <input
        id={id}
        data-testid={`input-${id}`}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        autoComplete={autoComplete}
        className={cn(
          'w-full h-11 px-4 rounded-lg',
          'bg-white dark:bg-slate-800',
          'text-slate-900 dark:text-slate-100',
          'placeholder:text-slate-400 dark:placeholder:text-slate-500',
          'transition-colors duration-150',
          'disabled:bg-slate-100 dark:disabled:bg-slate-800 disabled:cursor-not-allowed disabled:opacity-60',
          error
            ? 'border-2 border-rose-500 focus:border-rose-500 focus:ring-2 focus:ring-rose-500/20'
            : 'border border-slate-200 dark:border-slate-700 focus:border-indigo-500 focus:ring-2 focus:ring-indigo-500/20',
          'focus:outline-none'
        )}
      />

      {error && (
        <p
          data-testid={`error-${id}`}
          className="text-sm text-rose-600 dark:text-rose-400"
        >
          {error}
        </p>
      )}
    </div>
  );
};
